import { render, staticRenderFns } from "./userStampsMobile.vue?vue&type=template&id=0629fa6e"
import script from "./userStampsMobile.vue?vue&type=script&lang=js"
export * from "./userStampsMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports